import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class SessionUnavailableError extends EluveError {
  static override readonly errorName = 'SessionUnavailableError';
  readonly logLevel: LogLevel = 'warn';

  constructor(message = 'Session is unavailable', args?: EluveErrorArgs) {
    super(message, args);
  }
}
